module.exports = __webpack_public_path__ + "media/images/front/knowledge_note/knowledge_note_banner-5ac7d90799d63318965277232ad34d66.png";